import script from "./TheUpArrow.vue?vue&type=script&setup=true&lang=js"
export * from "./TheUpArrow.vue?vue&type=script&setup=true&lang=js"

import "./TheUpArrow.vue?vue&type=style&index=0&id=c6ce5fca&lang=css"

const __exports__ = script;

export default __exports__